import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { ProFormaForm } from '@atlassian/proforma-common-core/form';

export const formEditProformaFormResource: RouteResource<ProFormaForm> =
	createResource<ProFormaForm>({
		type: 'FORM_EDIT_PROFORMA_FORM_RESOURCE',
		getKey: ({
			match: {
				params: { helpCenterId, formId },
			},
		}) => `FORM_EDIT_PROFORMA_FORM_${helpCenterId}_${formId}`,
		getData: async (
			{
				match: {
					params: { helpCenterId, formId },
				},
			},
			{ tenantContext: { cloudId } },
		) => {
			const response = await performGetRequest<ProFormaForm>(
				`/gateway/api/proforma/cloudid/${cloudId}/api/frontend/jira/help-center/${helpCenterId}/admin/forms/${formId}`,
			);

			const form: ProFormaForm = JSON.parse(JSON.stringify(response));

			// Any response data manipulation here also needs to be mirrored
			// in onFormSaved in src/packages/servicedesk/customer-service-form-edit/src/ui/issue-type-page/IssueTypePage.tsx
			const attachmentKey = Object.values(form.design.questions).find(
				// FormQuestionType.Attachment = 'at' (@atlassian/proforma-common-core/form-system-models)
				(question) => question.type === 'at',
			)?.questionKey;

			if (attachmentKey) {
				form.design.questions[attachmentKey].jiraField = 'attachment';
			}

			return form;
		},
		maxAge: 0,
		isBrowserOnly: true,
	});
